import { Controller } from "@hotwired/stimulus"

// Keeps the singular itemized-bill destination tuple coherent for old
// application instances that can receive a form rendered by a new instance
// during a rolling deploy. New instances persist every checked array value;
// old instances receive the first checked email's contact (otherwise the first
// fax's) and only checked values that belong to that same contact.
export default class extends Controller {
  static targets = ["destination", "contact", "email", "fax"]

  connect() {
    this.sync()
  }

  sync() {
    const selectedEmails = this.selectedDestinations("email")
    const selectedFaxes = this.selectedDestinations("fax")
    const primary = selectedEmails[0] || selectedFaxes[0]
    const contactId = primary?.dataset.scaItemizedLegacyFallbackContactId || ""

    this.contactTarget.value = contactId
    this.emailTarget.value = this.firstValueForContact(selectedEmails, contactId)
    this.faxTarget.value = this.firstValueForContact(selectedFaxes, contactId)
  }

  selectedDestinations(channel) {
    return this.destinationTargets.filter((destination) => (
      destination.checked && destination.dataset.scaItemizedLegacyFallbackChannel === channel
    ))
  }

  firstValueForContact(destinations, contactId) {
    return destinations.find((destination) => (
      destination.dataset.scaItemizedLegacyFallbackContactId === contactId
    ))?.value || ""
  }
}
